const encodeQueryParam = (key: string | [string, any], value?: any): string | undefined => {
	if (Array.isArray(key)) {
		value = key[1];
		key = key[0];
	}
	const prefix = encodeURIComponent(key) + "=";
	const components: string[] = [];
	if (Array.isArray(value)) {
		if (value.length === 0) {
			return undefined;
		}
		for (let i = 0; i < value.length; ++i) {
			components.push(prefix + encodeURIComponent(value[i]));
		}
	} else {
		if (!value) {
			return undefined;
		}
		components.push(prefix + encodeURIComponent(value));
	}

	return components.join("&");
};

export const encodeQueryParams = (params: Record<string, any>): string => {
	const query = Object.entries(params).map(encodeQueryParam).filter(Boolean).join("&");
	if (query !== "") {
		return "?" + query;
	} else {
		return "";
	}
};
